import React from 'react';
import { Section } from './ui/Section';
export function LegalPack() {
  return <Section variant="alt" data-id="element-147">
      <div className="bg-gradient-navy text-white rounded-lg p-6 md:p-8 max-w-4xl mx-auto shadow-navy" data-id="element-148">
        <div className="text-center mb-4" data-id="element-149">
          <div className="inline-block bg-brand-accent text-brand-primary px-4 py-1 rounded-full font-body font-bold text-xs mb-3" data-id="element-150">
            💎 SOLO EN PREMIUM
          </div>
          <h2 className="font-display text-2xl md:text-3xl font-bold mb-2" data-id="element-151">
            PACK LEGAL BLINDADO
          </h2>
          <p className="text-brand-accent font-heading text-lg mb-1" data-id="element-152">
            Valor: 99€
          </p>
          <p className="text-white/80 text-sm" data-id="element-153">
            Protege tu consulta y honorarios desde el primer paciente
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-2 text-sm" data-id="element-154">
          {['Contrato + Consentimiento (RGPD)', 'Política Cancelaciones', 'Historia Clínica Completa', 'Registro Sesión SOAP', 'Informe Alta y Derivación', 'Guía Facturación IVA exento'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-155">
              <span className="text-brand-accent shrink-0" data-id="element-156">✓</span>
              <span className="font-body text-white" data-id="element-157">{item}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}